import {DateTime, IANAZone} from 'luxon';

/**
 * This will use luxon to parse the event date time from the timestamp format EventModel uses.
 *
 * This supports timezones, and will default to 'America/Los_Angeles' if no timezone is provided.
 *
 * @param eventTimestamp string
 * @param eventTimezone string
 * @returns DateTime
 */

export const parseEventDateTime = (eventTimestamp: string, eventTimezone?: string): DateTime => {
  const isoDatetime = DateTime.fromISO(eventTimestamp, {setZone: true});
  const timezone = new IANAZone(eventTimezone || 'America/Los_Angeles');
  if (timezone.isValid) {
    return isoDatetime.setZone(timezone);
  }
  return isoDatetime;
};
